module.exports = __webpack_public_path__ + "img/avatar.54619073.jpg";